import { create } from "zustand";
import type { JargonStore } from "./types";
import {
    getJargonEntries,
    createJargonEntries,
    updateJargonEntry,
    deleteJargonEntry
} from "../../../api";
import { asyncActionWrapper } from "../utils/asyncActionWrapper";


export const useJargonStore = create<JargonStore>((set, get) => ({
    loading: false,
    jargon: [],
    asyncActionWrapper,
    fetchJargon: async () => {
        set({ loading: true });
        set({ jargon: await getJargonEntries() });
        set({ loading: false });
    },
    createJargonEntriesWrapper: async (values: any) => {
        await get().asyncActionWrapper(
            async () => {
                await createJargonEntries(values);
            },
            "Jargon entries created successfully",
            "Error creating jargon entries"
        );
        get().fetchJargon();
    },
    updateJargonEntryWrapper: async (values: any) => {
        await get().asyncActionWrapper(
            async () => {
                await updateJargonEntry(values);
            },
            `Jargon entry ${values.abbreviation} updated successfully`,
            `Error updating jargon entry ${values.abbreviation}`
        );
        get().fetchJargon();
    },
    deleteJargonEntriesWrapper: async (ids: string[]) => {
        await get().asyncActionWrapper(
            async () => {
                await Promise.all(ids.map((id) => deleteJargonEntry(id)));
            },
            `Jargon entries ${ids.join(", ")} deleted successfully`,
            `Error deleting jargon entries ${ids.join(", ")}`
        );
        get().fetchJargon();
    },
}));
